import validate from "/workspace/source/hcon-app-stg-hcon-fo-ui/node_modules/nuxt/dist/pages/runtime/validate.js";
import _30_45route_45check_45auth_45global from "/workspace/source/hcon-app-stg-hcon-fo-ui/src/middleware/30.route-check-auth.global.ts";
import manifest_45route_45rule from "/workspace/source/hcon-app-stg-hcon-fo-ui/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _30_45route_45check_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}